import * as React from 'react';
import { Grid, Input } from 'semantic-ui-react';
import Selection from '../../../shared/component/selection_component';
import { AppliedModifierFormData } from '../../constant/applied_modifiers_constants';
import * as AppliedModifiersConstants from '../../constant/applied_modifiers_constants';
import { UI_CONSTANTS } from '../../constant/applied_modifiers_constants';

export interface BasicInfoSectionProps {
  formData: AppliedModifierFormData;
  onFieldChange: (field: string, value: any) => void;
  markFieldForRequiredValidation: (fieldName: string) => boolean;
  markFieldForValidation: (fieldName: string) => boolean;
  validationMsg?: Record<string, string>;
  onClearValidation?: (fieldName: string) => void;
}

export const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({
  formData,
  onFieldChange,
  markFieldForRequiredValidation,
  markFieldForValidation,
  validationMsg = {},
  onClearValidation
}) => {
  const claimProcessingRuleName = 'claim_processing_rule_name';
  const onChangeSettingName = (e: React.ChangeEvent<HTMLInputElement>) => {
    onFieldChange('setting_name', e.target.value);
    // Clear validation message when user starts typing
    if (onClearValidation && validationMsg && validationMsg[claimProcessingRuleName]) {
      onClearValidation(claimProcessingRuleName);
    }
  };

  // Helper function to get validation message for setting name
  // The backend returns propertyName as "claim_processing_rule_name" (from AppliedModifierPropertyName.Name)
  const getSettingNameValidationMessage = () => {
    return validationMsg[claimProcessingRuleName] || '';
  };

  // Check if setting name has validation error
  const hasSettingNameValidation = () => {
    return !!validationMsg[claimProcessingRuleName];
  };

  const onChangeStatus = (value: string, e: any) => {
    onFieldChange('active_status', value === 'true');
  };

  return (
    <Grid.Row>
      <Grid.Column width={10}>
        <label>
          {UI_CONSTANTS.LABELS.SETTING_NAME}
          <span className={markFieldForRequiredValidation(AppliedModifiersConstants.field_identifier.setting_name) ? UI_CONSTANTS.CSS_CLASSES.REQUIRED_ALERT : UI_CONSTANTS.CSS_CLASSES.REQUIRED_ALERT_NORMAL}>
            {UI_CONSTANTS.LABELS.REQUIRED_INDICATOR}
          </span>
        </label>
        <Input
          autoComplete='off'
          name={AppliedModifiersConstants.field_identifier.setting_name}
          id={AppliedModifiersConstants.field_identifier.setting_name}
          type='text'
          defaultValue={formData.setting_name || UI_CONSTANTS.DATA_PROCESSING.EMPTY_STRING}
          onChange={onChangeSettingName}
          maxLength={50}
          className={
            markFieldForValidation(AppliedModifiersConstants.field_identifier.setting_name) || hasSettingNameValidation()
              ? UI_CONSTANTS.CSS_CLASSES.REQUIRED_BORDER_INPUT
              : UI_CONSTANTS.DATA_PROCESSING.EMPTY_STRING
          }
          data-testid={AppliedModifiersConstants.field_identifier.setting_name}
        />
        {hasSettingNameValidation() && (
          <div className='requiredText' style={{ color: 'red' }}>
            {getSettingNameValidationMessage()}
          </div>
        )}
      </Grid.Column>
      <Grid.Column width={6}>
        <label>
          <span>
            {UI_CONSTANTS.LABELS.STATUS}
          </span>
        </label>
        <Selection
          id={AppliedModifiersConstants.field_identifier.active_status}
          name={AppliedModifiersConstants.field_identifier.active_status}
          options={AppliedModifiersConstants.active_status_list}
          defaultValue={formData.active_status !== undefined ? formData.active_status.toString() : 'true'}
          isRequired={markFieldForValidation(AppliedModifiersConstants.field_identifier.active_status)}
          onChange={onChangeStatus}
          data-testid={AppliedModifiersConstants.field_identifier.active_status}
        />
      </Grid.Column>
    </Grid.Row>
  );
};
